import React from 'react';
import { MailChunky } from '@eventbrite/eds-iconography';

import NotificationScreen from '../components/NotificationScreen';

import { TEXT_TOKEN_EXPIRES_TIME } from '../constants/messages';

const ModalMessage = ({
    iconType = <MailChunky />,
    iconColor = 'ui-700',
    headerText,
    subtitleText,
    usesNewStyles = true,
    headerClassName = 'eds-text-hs eds-l-mar-bot-3',
    subtitleClassName = 'eds-text--center es-text-bm eds-text-bm eds-l-mar-hor-3 eds-l-mar-bot-8',
    expirationTimeText = TEXT_TOKEN_EXPIRES_TIME,
}) => {
    return (
        <div>
            <NotificationScreen
                iconType={iconType}
                iconColor={iconColor}
                headerText={headerText}
                usesNewStyles={usesNewStyles}
                headerClassName={headerClassName}
            />

            <div
                className={subtitleClassName}
                data-testid="page-header-subtitle"
            >
                {subtitleText}
            </div>

            {expirationTimeText && expirationTimeText}
        </div>
    );
};

export default ModalMessage;
